import CheckoutPaymentScreen from './CheckoutPaymentScreen';

export default CheckoutPaymentScreen;
